module.exports = __webpack_public_path__ + "static/media/paymentScreen-applyCouponAndLoyalty.fae07d68.png";